export class CardTableOptions {
	rowId?: string;
	titleProperty?: string;
	subTitleProperty?: string;
	contentProperty?: string;
	additionalProperty?: string;
	indicatorColorProperty?: string;
	selectedProperty?: string;
	isSelectable?: boolean = false;
	flexCardLayout?: boolean = false;
	propertyRowExclusions?: string[];
	stylePropertyPrefix?: string;
	clickableFlexCard?: boolean;
	selectAll?: boolean;
	textSize: "small" | "regular" = "regular";
}
